import { createGraphqlBaseApi, resolveGraphqlUrl } from '@vipso/shared';
import { logout, setTokens } from './authSlice';

/** Structural slice view — importing `RootState` here would make the store type circular. */
type AuthStateSlice = {
  auth: {
    accessToken: string | null;
    refreshToken: string | null;
  };
};

const REFRESH_MUTATION = `
  mutation RefreshSession($refreshToken: String!) {
    refreshSession(refreshToken: $refreshToken) {
      accessToken
      refreshToken
    }
  }
`;

export const baseApi = createGraphqlBaseApi({
  url: resolveGraphqlUrl(),
  reducerPath: 'api',
  tagTypes: [
    'Customer',
    'Procurement',
    'Tenant',
    'Vendor',
    'Product',
    'Warehouse',
    'Chamber',
    'Floor',
    'Rack',
    'Labour',
    'Transport',
    'Staff',
    'Task',
    'SystemNotification',
    'InventoryTransfer',
    'Billing',
  ] as const,
  refreshMutation: REFRESH_MUTATION,
  refreshPayloadKey: 'refreshSession',
  getTokens: (state) => ({
    accessToken: (state as AuthStateSlice).auth.accessToken,
    refreshToken: (state as AuthStateSlice).auth.refreshToken,
  }),
  setTokens,
  logout,
});

export default baseApi;
